import React, {Component} from 'react'
import Caregivers from '../components/Caregivers'

class CaregiversPage extends Component {
  render() {
    return (
        <Caregivers/>
    )
  }
}

export default CaregiversPage
